// Based of https://github.com/dtao/nearest-color

import { hexToRgb } from '@/utils/hexToRgb';

export function nearestColor(color: string, palette: string[]) {
  const colorToRgb = hexToRgb(color);

  const mappedColors = palette.map((paletteColor) => hexToRgb(paletteColor));

  let distanceSq = 0,
    minDistanceSq = Infinity,
    closestHex = '',
    closestRgb = {
      r: 0,
      g: 0,
      b: 0,
    },
    paletteIndex = 0;

  mappedColors.forEach((mappedColors, i) => {
    distanceSq =
      Math.pow(colorToRgb.r - mappedColors.r, 2) +
      Math.pow(colorToRgb.g - mappedColors.g, 2) +
      Math.pow(colorToRgb.b - mappedColors.b, 2);

    if (distanceSq < minDistanceSq) {
      minDistanceSq = distanceSq;
      closestHex = palette[i];
      paletteIndex = i;
      closestRgb = mappedColors;
    }
  });

  return {
    color: color,
    closestHex,
    closestRgb,
    paletteIndex,
    distance: Math.sqrt(minDistanceSq),
  };
}
